export function isNullItem(s) {
  return s.type === 'null';
}